export default function (element, data) {

    window.addEventListener("mobiletextupdate", function(event) {
        const detail = event.detail.text;
        element.classList.add("hide");

        setTimeout(function() {
            element.classList.remove("hide");
            element.innerText = detail;
        }, 500);

    });

    window.addEventListener("pagination", function() {
        element.innerText = "";
    })
}
